import {
  CityIcon,
  EditLocationIcon,
  OffstreetParkingIcon,
  ParkingAreaIcon,
  ParkingPaymentIcon,
  PoliciesIcon,
  TrafficIcon,
  UserWhiteIcon,
  FinanceIcon,
} from "components/icons";
import React from "react";
import { routes } from "routes/constants";
import { RoleType } from "store/auth/auth.type";
import { ChartNoAxesColumnIncreasing } from "lucide-react";

export const menuItems: MenuItem[] = [
  {
    ...routes.root,
    menuIcon: ParkingAreaIcon,
  },
  {
    ...routes.urbanFeature,
    menuIcon: TrafficIcon,
  },
  {
    ...routes.streetStatistics,
    menuIcon: ChartNoAxesColumnIncreasing,
  },
  {
    ...routes.offstreetParking,
    menuIcon: OffstreetParkingIcon,
  },
  {
    ...routes.restriction,
    menuIcon: EditLocationIcon,
  },
  {
    ...routes.policies,
    menuIcon: PoliciesIcon,
  },
  {
    ...routes.parkingPayment,
    menuIcon: ParkingPaymentIcon,
  },
  {
    ...routes.finance,
    menuIcon: FinanceIcon,
  },
  {
    ...routes.cities,
    menuIcon: CityIcon,
  },
  {
    ...routes.users,
    menuIcon: UserWhiteIcon,
  },
];

export type MenuItem = {
  path: string;
  displayName: string;
  menuIcon: React.FC<React.SVGProps<SVGSVGElement>>;
  roles: RoleType[];
};
